module.exports = __webpack_public_path__ + "static/media/fondoolas2.945ce2e2.webp";